import React, {Component} from 'react';
import Select from 'react-select';
import axios from 'axios';
import Utils from './Utils';
import DecimalHelpBlock from './DecimalHelpBlock';

export default class ContractFundingFrameworkContract extends Component {
    constructor() {
        super();

        this.state = {
            framework_contract_id: 0,
            article_amounts: [],
            framework_contracts: [],
            articles: []
        };

        this.handleFrameworkContractChange = this.handleFrameworkContractChange.bind(this);
        this.getArticles = this.getArticles.bind(this);
        this.handleArticleAmountChanged = this.handleArticleAmountChanged.bind(this);
        this.handleArticleVATChange = this.handleArticleVATChange.bind(this);
    }

    componentWillMount() {
        let framework_contracts = window.framework_contracts;
        let article_amounts = this.props.articleAmounts;
        let new_article_amounts = [];
        for (let key in article_amounts) {
            if (article_amounts.hasOwnProperty(key)) {
                let item = article_amounts[key];
                new_article_amounts[item.article_id] = {
                    article_id: item.article_id,
                    contract_amount_comma: item.contract_amount_comma,
                    contract_amount_vat_comma: item.contract_amount_vat_comma,
                    contract_vat_comma: item.contract_vat_comma,
                };
            }
        }
        this.setState({
            framework_contract_id: this.props.frameworkContractId,
            article_amounts: new_article_amounts,
            framework_contracts: framework_contracts
        }, () => {
            this.getArticles();
            let amounts = this.state.article_amounts;
            amounts.forEach((amount, index) => {
                if (((amount.contract_amount_comma !== undefined) && (amount.contract_amount_comma !== ""))
                    && ((amount.contract_vat_comma !== undefined) && (amount.contract_vat_comma !== ""))) {

                    let vat = parseFloat(amount.contract_vat_comma.replace(",", "."));
                    amount.contract_amount_vat_comma = Utils.calculateAmountVATFromVAT(vat, amount.contract_amount_comma);
                }

            });
        });
    }

    getArticles(resetArticleAmounts) {
        if (this.state.framework_contract_id != 0) {
            axios
                .get("/contracts/ajax/framework_contracts/" + this.state.framework_contract_id + "/articles")
                .then((response) => {
                    if (resetArticleAmounts) {
                        let article_amounts = [];
                        let data = response.data;
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                let item = data[key];
                                article_amounts[item.id] = {
                                    article_id: item.id,
                                    contract_amount_vat_comma: "",
                                    contract_amount_comma: "",
                                    contract_vat_comma: "",
                                };
                            }
                        }
                        this.setState({
                            articles: data,
                            article_amounts: article_amounts,
                        });
                    } else {
                        this.setState({
                            articles: response.data
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        framework_contract_id: 0,
                        articles: []
                    });
                });
        }
    }

    handleFrameworkContractChange(e) {
        this.setState({
            framework_contract_id: e.value
        }, () => {
            this.getArticles(true);
        });
    }

    handleArticleAmountChanged(e, idx) {
        let article_amounts = this.state.article_amounts;
        let value = Utils.handleDecimals(e.target.value);

        if (!article_amounts[idx]) {
            article_amounts[idx] = {
                article_id: idx,
                contract_amount_comma: "",
                contract_amount_vat_comma: "",
                contract_vat_comma: "",
            };
        } else {
            let vat = article_amounts[idx].contract_vat_comma;
            if (vat === "") {
                vat = '0';
            }
            vat = parseFloat(vat.replace(",", "."));
            article_amounts[idx].contract_amount_vat_comma = Utils.calculateAmountVATFromVAT(vat, value);
        }

        article_amounts[idx].contract_amount_comma = value;

        this.setState({article_amounts});
    }

    handleArticleVATChange(e, idx) {
        let article_amounts = this.state.article_amounts;
        let value = Utils.handleDecimals(e.target.value);
        let vat = parseFloat(e.target.value.replace(",", "."));

        if (!article_amounts[idx]) {
            article_amounts[idx] = {
                article_id: idx,
                contract_amount_comma: "",
                contract_amount_vat_comma: "",
            };
        } else {
            let amount = article_amounts[idx].contract_amount_comma;
            if (amount === "") {
                amount = '0';
            }
            article_amounts[idx].contract_amount_vat_comma = Utils.calculateAmountVATFromVAT(vat, amount);
        }

        article_amounts[idx].contract_vat_comma = value;

        this.setState({article_amounts});
    }

    render() {
        let articles = [];
        let framework_contract_articles = this.state.articles;

        for (let key in framework_contract_articles) {
            if (framework_contract_articles.hasOwnProperty(key)) {
                let article = framework_contract_articles[key];
                let is_amount_defined = (this.state.article_amounts[article.id] && this.state.article_amounts[article.id].contract_amount_comma);
                let is_article_id_defined = (this.state.article_amounts[article.id] && this.state.article_amounts[article.id].article_id);
                let is_amount_vat_defined = (this.state.article_amounts[article.id] && this.state.article_amounts[article.id].contract_amount_vat_comma);
                let is_vat_defined = (this.state.article_amounts[article.id] && this.state.article_amounts[article.id].contract_vat_comma);

                articles.push(
                    <tr key={article.id}>
                        <td>{article.title}</td>
                        <td>{article.available_amount_formatted}</td>
                        <td>{article.fullness_percentage_formatted} %</td>
                        <td>
                            <input type="text"
                                   className="form-control"
                                   name={"article_amounts[" + article.id + "][contract_amount_comma]"}
                                   value={(is_amount_defined ? this.state.article_amounts[article.id].contract_amount_comma : "")}
                                   onChange={(e) => {
                                       this.handleArticleAmountChanged(e, article.id)
                                   }}
                            />
                            <input type="hidden"
                                   name={"article_amounts[" + article.id + "][article_id]"}
                                   value={(is_article_id_defined ? this.state.article_amounts[article.id].article_id : "")}/>
                        </td>
                        <td>
                            <input type="text"
                                   className="form-control"
                                   name={"article_amounts[" + article.id + "][contract_vat_comma]"}
                                   value={(is_vat_defined ? this.state.article_amounts[article.id].contract_vat_comma : "")}
                                   onChange={(e) => {
                                       this.handleArticleVATChange(e, article.id)
                                   }}
                            />
                        </td>
                        <td>
                            <input type="text"
                                   readOnly
                                   className="form-control"
                                   name={"article_amounts[" + article.id + "][contract_amount_vat_comma]"}
                                   value={(is_amount_vat_defined ? this.state.article_amounts[article.id].contract_amount_vat_comma : "")}
                            />
                        </td>
                    </tr>
                );
            }
        }

        return (
            <div>
                <div className="form-group">
                    <label htmlFor="framework_contract_id" className="col-md-4 control-label">
                        {window.__js_contracts.framework_contract}*
                    </label>
                    <div className="col-md-8">
                        <Select name="framework_contract_id"
                                id="framework_contract_id"
                                value={this.state.framework_contract_id}
                                options={this.state.framework_contracts}
                                onChange={this.handleFrameworkContractChange}>
                        </Select>
                    </div>
                </div>
                <br/>
                <div className={"form-group" + (this.state.framework_contract_id === 0 ? " hidden" : "")}>
                    <label className="col-md-4 control-label">
                        {window.__js_contracts.articles_table}
                    </label>
                    <div className="col-md-8">
                        <div className="table-responsive">
                            <table className="table table-hover table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{window.__js_contracts.article_title}</th>
                                    <th>{window.__js_contracts.available_balance}</th>
                                    <th>{window.__js_contracts.completeness_percentage}</th>
                                    <th>{window.__js_contracts.amount}</th>
                                    <th>{window.__js_contracts.vat_rate}</th>
                                    <th>{window.__js_contracts.amount_with_vat}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {articles}
                                </tbody>
                            </table>
                        </div>
                        <div className="pull-right">
                            <DecimalHelpBlock/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}